// import { msalInstance } from '.';
// import { loginRequest } from './authConfig';
import { CurrentToken } from './contexts/auth';
import { Configuration, ConfigurationParameters, ErrorContext, FetchParams, Middleware, ResponseContext } from './data';

// class APIMiddleware implements Middleware {
//     onError(context: ErrorContext): Promise<void | Response> {
//         console.log(context);
//         return Promise.resolve(context.response);
//     }
// }


const configParams: ConfigurationParameters = {
    basePath: process.env.REACT_APP_API_URL,
    // basePath: (window as any).ENV.WebAPI,
    apiKey: () => {
      var token =  CurrentToken;

      var retVal='Bearer ' + token;

      // console.log('token:' + retVal);

      return retVal;
    }
  };
  
  export const apiConfiguration = new Configuration(configParams);